import React from "react";
import { moment, renderNumberGreaterThan100 } from "../common/common";
import { commonErr } from "../common/errors";

import { getOwnerReviews, getTravelerReviews } from "../../model/car";

import { Reviews } from "../car/carreviews";

import { IcStarRating } from "../common/svg";

const TabMode = ({ profile, reviewType, reviewTypeOwnerChange, reviewTypeTravelerChange }) => {
	return (
		<>
			{profile.owner.totalTrips > 0 && profile.traveler.totalTrips > 0 && (
				<div className="tab-mode">
					{profile.traveler.totalTrips > 0 && (
						<div onClick={reviewTypeOwnerChange} className={`tab-mode__item ${reviewType === 0 ? "active" : ""}`}>
							Chủ xe
						</div>
					)}
					{profile.owner.totalTrips > 0 && (
						<div onClick={reviewTypeTravelerChange} className={`tab-mode__item ${reviewType === 1 ? "active" : ""}`}>
							Khách thuê
						</div>
					)}
				</div>
			)}
		</>
	);
};

export default class ProfileReviews extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			reviews: props.reviews || null,
			profiles: props.profiles || null,
			more: props.more ? 1 : 0,
			reviewType: props.reviewType,
		};
	}

	componentDidMount() {
		if (!this.props.reviews || this.props.reviews.length === 0) {
			if (this.props.profile.owner.totalTrips > 0) {
				getTravelerReviews(this.props.profile.uid, 0, 0, 0).then((resp) => {
					if (resp.data.error >= commonErr.SUCCESS && resp.data.data) {
						this.setState({
							err: resp.data.error,
							reviews: resp.data.data.reviews,
							profiles: resp.data.data.profiles,
							totalReviews: resp.data.data.totalReviews,
							more: resp.data.data.more,
						});
					}
				});
			} else if (this.props.profile.traveler.totalTrips > 0) {
				getOwnerReviews(this.props.profile.uid, 0, 0, 0).then((resp) => {
					if (resp.data.error >= commonErr.SUCCESS && resp.data.data) {
						this.setState({
							err: resp.data.error,
							reviews: resp.data.data.reviews,
							profiles: resp.data.data.profiles,
							totalReviews: resp.data.data.totalReviews,
							more: resp.data.data.more,
						});
					}
				});
				this.setState({
					reviewType: 0,
				});
			}
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if ((!this.props.reviews || this.props.reviews.length === 0) && prevState.reviewType !== this.state.reviewType) {
			if (this.state.reviewType === 1) {
				getTravelerReviews(this.props.profile.uid, 0, 0, 0).then((resp) => {
					if (resp.data.error >= commonErr.SUCCESS && resp.data.data) {
						this.setState({
							err: resp.data.error,
							reviews: resp.data.data.reviews,
							profiles: resp.data.data.profiles,
							totalReviews: resp.data.data.totalReviews,
							more: resp.data.data.more,
						});
					}
				});
			} else {
				getOwnerReviews(this.props.profile.uid, 0, 0, 0).then((resp) => {
					if (resp.data.error >= commonErr.SUCCESS && resp.data.data) {
						this.setState({
							err: resp.data.error,
							reviews: resp.data.data.reviews,
							profiles: resp.data.data.profiles,
							totalReviews: resp.data.data.totalReviews,
							more: resp.data.data.more,
						});
					}
				});
			}
		}
	}

	getReviewsMore = () => {
		if (this.state.reviewType === 0) {
			getOwnerReviews(this.props.profile.uid, 0, this.state.reviews.length, 0).then((resp) => {
				if (resp.data.error >= commonErr.SUCCESS && resp.data.data) {
					this.setState({
						err: resp.data.error,
						reviews: this.state.reviews.concat(resp.data.data.reviews),
						profiles: this.state.profiles.concat(resp.data.data.profiles),
						more: resp.data.data.more,
					});
				}
			});
		} else {
			getTravelerReviews(this.props.profile.uid, 0, this.state.reviews.length, 0).then((resp) => {
				if (resp.data.error >= commonErr.SUCCESS && resp.data.data) {
					this.setState({
						err: resp.data.error,
						reviews: this.state.reviews.concat(resp.data.data.reviews),
						profiles: this.state.profiles.concat(resp.data.data.profiles),
						more: resp.data.data.more,
					});
				}
			});
		}
	};

	reviewTypeOwnerChange = () => {
		this.setState({
			reviewType: 0,
		});
	};

	reviewTypeTravelerChange = () => {
		this.setState({
			reviewType: 1,
		});
	};

	render() {
		var reviews;
		var profiles;
		var profile = this.props.profile;
		var rating;
		if (this.state.err >= commonErr.SUCCESS) {
			if (this.state.reviewType === 1) {
				reviews = this.state.reviews;
				profiles = this.state.profiles;
				if (profile.owner && this.state.totalReviews > 0) {
					rating = (
						<div className="review-title">
							<div className="review-info">
								<div className="rate-review">
									<div className="wrap-svg">
										<IcStarRating />
									</div>
									<p className="rate">{profile.owner.rating.avg.toFixed(1)}</p>
								</div>
								<span className="dot">•</span>
								<p className="total-review">{renderNumberGreaterThan100(this.state.totalReviews)} Đánh giá</p>
							</div>
							<TabMode
								profile={profile}
								reviewType={this.state.reviewType}
								reviewTypeTravelerChange={this.reviewTypeTravelerChange}
								reviewTypeOwnerChange={this.reviewTypeOwnerChange}
							/>
						</div>
					);
				}
			} else {
				reviews = this.state.reviews;
				profiles = this.state.profiles;
				if (profile.traveler && this.state.totalReviews > 0) {
					rating = (
						<div className="review-title">
							<div className="review-info">
								<div className="rate-review">
									<div className="wrap-svg">
										<IcStarRating />
									</div>
									<p className="rate">{profile.traveler.rating.avg.toFixed(1)}</p>
								</div>
								<span className="dot">•</span>
								<p className="total-review">{renderNumberGreaterThan100(this.state.totalReviews)} Đánh giá</p>
							</div>
							<TabMode
								profile={profile}
								reviewType={this.state.reviewType}
								reviewTypeTravelerChange={this.reviewTypeTravelerChange}
								reviewTypeOwnerChange={this.reviewTypeOwnerChange}
							/>
						</div>
					);
				}
			}
		}

		if (reviews) {
			return (
				<div className="content-item review">
					{rating}
					<div className="list-reviews">
						{reviews.map((review) => {
							if (review.name && review.name !== "") {
								return <Reviews key={review.id} review={review} />;
							} else if (profiles) {
								var ownerProfile;
								if (profiles.length > 0) {
									for (var i = 0; i < profiles.length; ++i) {
										if (profiles[i].uid === review.uid) {
											ownerProfile = profiles[i];
											break;
										}
									}
								}
								return <Reviews key={review.id} review={review} reviewProfile={ownerProfile} />;
							}
						})}
					</div>
					{this.state.more === 1 && (
						<div className="btn-see-more">
							<a className="btn btn--s btn-secondary" onClick={this.getReviewsMore}>
								Xem thêm
							</a>
						</div>
					)}
				</div>
			);
		} else {
			return null;
		}
	}
}
